import { useRef } from 'react';

// One tap can arrive as two clicks (AndroidDevStudio's phone preview does it on every
// tap, and Android's "ghost click" does it now and then). For a button that switches
// something on and off, that means "on" and "off" in the same instant: nothing happens.
// guard(fn) lets the first call through and drops any other within the next moment.
//
//   const guard = useTapGuard();
//   <button onClick={guard(toggle)} />
// Handlers that are different actions get different keys, so that a quick second tap on
// another button is not mistaken for the echo of the first one.
export function useTapGuard(ms = 350) {
  const last = useRef({});
  return (fn, key = 'default') => (...args) => {
    const now = Date.now();
    if (now - (last.current[key] || 0) < ms) return undefined;
    last.current[key] = now;
    return fn(...args);
  };
}
